/**
 * Post image to Cloudinary
 */
export async function postImageToCloudinary(endpoint, image) {
  return await fetch(endpoint, {
    method: "POST",
    body: image,
  });
}
